import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { getAllHotelBooking } from "../services/userservice";
import moment from "moment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const HolidayBookings = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedBooking, setSelectedBooking] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await getAllHotelBooking();
                setBookings(response || []);
                console.log("response", response)
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const filteredBookings = bookings.filter((booking) =>
        booking?.hotel_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        booking?.swt_booking_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        booking?.billing_email?.toLowerCase().includes(searchTerm.toLowerCase())
    );



    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedBooking(null);
    };

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;



    // Table rows to show per page Start

    const indexOfLastBooking = currentPage * rowsPerPage;
    const indexOfFirstBooking = indexOfLastBooking - rowsPerPage;
    const currentBookings = filteredBookings.slice(indexOfFirstBooking, indexOfLastBooking);

    // bottom pagination start

    const totalPages = Math.ceil(filteredBookings.length / rowsPerPage);

    const renderPageNumbers = () => {
        const pages = [];
        const maxPagesToShow = 3;

        if (totalPages <= 10) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            // Always show first 3 pages
            pages.push(1, 2, 3);

            // Show "..." if currentPage is beyond 5
            if (currentPage > 5) {
                pages.push("...");
            }

            // Show current page and neighbors
            const start = Math.max(4, currentPage - 1);
            const end = Math.min(totalPages - 3, currentPage + 1);

            for (let i = start; i <= end; i++) {
                if (!pages.includes(i)) pages.push(i);
            }

            // Show "..." if currentPage is far from end
            if (currentPage < totalPages - 4) {
                pages.push("...");
            }

            // Always show last 3 pages
            pages.push(totalPages - 2, totalPages - 1, totalPages);
        }

        return pages.map((page, index) => (
            <li
                key={index}
                className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
            >
                {page === "..." ? (
                    <span className="page-link">...</span>
                ) : (
                    <button className="page-link" onClick={() => setCurrentPage(page)}>
                        {page}
                    </button>
                )}
            </li>
        ));
    };



    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Hotels Bookings</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Home</Link>
                                </li>
                                <li className="breadcrumb-item active">Hotels Bookings</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="d-md-flex align-items-center justify-content-end">
                                        <div className="card-tools">
                                            <div
                                                className="input-group input-group-sm"
                                                style={{ width: "250px" }}
                                            >
                                                <input
                                                    type="text"
                                                    name="table_search"
                                                    className="form-control float-right"
                                                    placeholder="Search"
                                                    value={searchTerm}
                                                    onChange={handleSearchChange}
                                                />
                                                <div className="input-group-append">
                                                    <button type="submit" className="btn btn-default">
                                                        <i className="fas fa-search" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card-body">

                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <div>
                                            <label className="me-2">Show</label>
                                            <select
                                                value={rowsPerPage}
                                                onChange={(e) => {
                                                    setRowsPerPage(parseInt(e.target.value));
                                                    setCurrentPage(1); // Reset to first page
                                                }}
                                                className="form-control mx-2 form-select d-inline-block w-auto"
                                            >
                                                <option value="10">10</option>
                                                <option value="25">25</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                            <span className="ms-2">entries</span>
                                        </div>
                                        <div>
                                            {/* Optional: Add search or pagination controls here */}
                                        </div>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Date</th>
                                                    <th>Booking ID</th>
                                                    <th>Customer </th>
                                                    <th>Hotel</th>
                                                    <th>CheckIn</th>
                                                    <th>CheckOut</th>
                                                    <th>Published</th>
                                                    <th>Offered</th>
                                                    <th>Sale Price</th>
                                                    <th>Tax & Fees</th>
                                                    <th>Discount</th>
                                                    <th>Payment</th>
                                                    <th>Booking</th>
                                                    <th>Vendor</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentBookings.map((booking, i) => (
                                                    <tr key={booking?.id}>
                                                        {console.log("booking", booking?.rooms?.[0]?.passengers?.[0]?.first_name)}
                                                        <td> {moment(booking?.created_at).format("DD-MM-YY")} </td>
                                                        <td>{booking?.swt_booking_id}</td>
                                                        {/* <td>{booking?.rooms?.[0]?.passengers?.[0]?.first_name}</td> */}
                                                        <td>
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={
                                                                    <Tooltip id={`tooltip-${i}`}>
                                                                        {booking?.rooms?.[0]?.passengers?.[0]?.first_name || "No Name"}
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <span className="text-truncate d-inline-block" style={{ maxWidth: "150px" }}>
                                                                    {booking?.rooms?.[0]?.passengers?.[0]?.first_name || "No Name"}
                                                                </span>
                                                            </OverlayTrigger>
                                                        </td>
                                                        {/* <td>{booking?.hotel_name}</td> */}
                                                        <td>
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={
                                                                    <Tooltip id={`tooltip-${i}`}>
                                                                        {booking?.hotel_name || "No Name"}
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <span className="text-truncate d-inline-block" style={{ maxWidth: "150px" }}>
                                                                    {booking?.hotel_name || "No Name"}
                                                                </span>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td> {moment(booking?.from_date).format("DD-MM-YY")} </td>
                                                        <td> {moment(booking?.to_date).format("DD-MM-YY")} </td>
                                                        <td> {Math.round(booking?.rooms?.[0]?.published_price_rounded_off)} </td>
                                                        <td> {Math.round(booking?.rooms?.[0]?.offered_price_rounded_off)} </td>
                                                        <td> {Math.round(booking?.total_amount)} (T/F:{Math.round(booking?.service_charge)})  </td>
                                                        <td> {Math.round(booking?.service_charge)}  </td>
                                                        <td> {Math.round(booking?.discount_amount)}  </td>
                                                        <td>
                                                            <span
                                                                className={`badge p-2 w-100 ${booking.payment_status === "SUCCESS"
                                                                    ? "badge-success"
                                                                    : booking.payment_status === "FAILED"
                                                                        ? "badge-danger"
                                                                        : "badge-warning"
                                                                    }`}
                                                            >
                                                                {booking.payment_status.toUpperCase()}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span
                                                                className={`badge p-2 w-100 ${booking.booking_status === "SUCCESS"
                                                                    ? "badge-success"
                                                                    : booking.booking_status === "FAILED"
                                                                        ? "badge-danger"
                                                                        : "badge-warning"
                                                                    }`}
                                                            >
                                                                {booking.booking_status.toUpperCase()}
                                                            </span>
                                                        </td>
                                                        <td>{booking?.vendor_type?.toUpperCase()}</td>
                                                        <td>
                                                            {/* <button
                                                                // onClick={() => fetchEnquiryData(booking?.id)}
                                                                className="btn btn-primary btn-sm"
                                                            >
                                                                View
                                                            </button> */}
                                                            <Link to={`/hotel-booking-details/${booking.id}`}>
                                                                <button className="btn btn-primary btn-sm">
                                                                    <i className="fa fa-eye"></i>
                                                                </button>
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="d-md-flex justify-content-between align-items-center mt-3">
                                        <div>
                                            Showing {indexOfFirstBooking + 1} to {Math.min(indexOfLastBooking, filteredBookings.length)} of {filteredBookings.length} entries
                                        </div>
                                        <nav>
                                            <ul className="pagination mb-0">
                                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                                    <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
                                                        Previous
                                                    </button>
                                                </li>

                                                {renderPageNumbers()}

                                                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                                    <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
                                                        Next
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div >
            </section >

            <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Booking Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p><strong>Name:</strong> {selectedBooking?.name || "N/A"}</p>
                    <p><strong>Email:</strong> {selectedBooking?.email || "N/A"}</p>
                    <p><strong>Mobile Number:</strong> {selectedBooking?.mobile_number || "N/A"}</p>
                    <p><strong>Enquiry Type:</strong> {selectedBooking?.enquiry_type || "N/A"}</p>
                    <p><strong>Package:</strong> {selectedBooking?.package?.package_name || "Not Assigned"}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div >
    );
};

export default HolidayBookings;
